const mutations = {
  changeUser: (state, user) => {
    state.user = user;
  }
};

export default {
  mutations
};
